module.exports = __webpack_public_path__ + "img/facility-manager-4187687278.fb861527.jpg";